"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KodenBinIcon = void 0;
const React = __importStar(require("react"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
const styled_components_1 = __importStar(require("styled-components"));
const Container = styled_components_1.default.div `
	${(props) => props.disabled &&
    (0, styled_components_1.css) `
			width: fit-content;
			cursor: not-allowed;
		`};
`;
const Icon = (0, styled_components_1.default)(Delete_1.default) `
	color: #f2abab;
	${(props) => props.disabled &&
    (0, styled_components_1.css) `
			cursor: not-allowed;
			color: grey;
		`};
`;
const KodenBinIcon = ({ id, className, disabled = false, onClick, }) => {
    return (React.createElement(Container, { disabled: disabled },
        React.createElement(IconButton_1.default, { id: id, disabled: disabled, className: className, component: "span", size: "medium", onClick: (e) => {
                if (!disabled) {
                    onClick(e);
                }
            } },
            React.createElement(Icon, { disabled: disabled }))));
};
exports.KodenBinIcon = KodenBinIcon;
exports.default = exports.KodenBinIcon;
//# sourceMappingURL=koden-bin-icon.js.map